<template>
  <div class="navbar">
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb class="breadcrumb-container" />

    <div class="right-menu">
      <template>
        <lang-select class="right-menu-item hover-effect" />
      </template>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img v-if="avatarAvailable" :src="favico" class="user-avatar" @error="avatarAvailable = false">
          <i v-else class="el-icon-user-solid user-avatar-fallback" />
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link to="/">
            <el-dropdown-item>
              {{ generateTitle('p99_nav_home') }}
            </el-dropdown-item>
          </router-link>
          
          <a target="_blank" href="https://ww2.siva-tech.com">
            <el-dropdown-item>{{ generateTitle('p99_nav_sivatech') }}
            </el-dropdown-item>
          </a>
          <!--
          <a target="_blank" href="https://panjiachen.github.io/vue-element-admin-site/#/">
            <el-dropdown-item>Docs</el-dropdown-item>
          </a>
          -->
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">{{ generateTitle('p99_nav_logout') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import LangSelect from '@/components/LangSelect'
import { generateTitle } from '@/utils/i18n'

export default {
  data() {
    return {
      favico: process.env.VUE_APP_STATIC_BASE_URL+'/favicon.ico',
      avatarAvailable: true
    }
  },
  components: {
    Breadcrumb,
    Hamburger,
    LangSelect
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar'])
  },
  methods: {
    generateTitle,
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout/'+ this.$store.getters.token)
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      this.$store.dispatch('user/resetToken').then(() => {
        location.reload()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
 height: 50px;
 overflow: hidden;
 position: relative;
 background: #fff;
 box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

 .hamburger-container {
  line-height: 46px;
  height: 100%;
  float: left;
  cursor: pointer;
  transition: background 0.3s;
  -webkit-tap-highlight-color: transparent;

  &:hover {
   background: rgba(0, 0, 0, 0.025);
  }
 }

 .breadcrumb-container {
  float: left;
 }

 .right-menu {
  float: right;
  height: 100%;
  line-height: 50px;

  &:focus {
   outline: none;
  }

  .right-menu-item {
   display: inline-block;
   padding: 0 8px;
   height: 100%;
   font-size: 18px;
   color: #5a5e66;
   vertical-align: text-bottom;

   &.hover-effect {
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
     background: rgba(0, 0, 0, 0.025);
    }
   }
  }

  .avatar-container {
   margin-right: 30px;

   .avatar-wrapper {
    margin-top: 5px;
    position: relative;

    .user-avatar {
     cursor: pointer;
     width: 40px;
     height: 40px;
     border-radius: 10px;
    }

    .user-avatar-fallback {
     display: inline-flex;
     align-items: center;
     justify-content: center;
     width: 40px;
     height: 40px;
     border-radius: 8px;
     background: #eef2f6;
     color: #52677d;
     font-size: 22px;
    }

    .el-icon-caret-bottom {
     cursor: pointer;
     position: absolute;
     right: -20px;
     top: 25px;
     font-size: 12px;
    }
   }
  }
 }
}
</style>
